<div class="vote-toggle">
  <span class="row align-top">
    <span class="label col-md-6 col-xl-5">{{ voteType.name }}</span>
    <div class="toggle-group col-md-6">
      <button
        [class]="{
          toggle: true,
          negative: true,
          checked: vote?.status === false
        }"
        role="button"
        type="button"
        (click)="handleClick(false)"
        [disabled]="
          (!permsService.userPerms['COMMITTEEVOTETYPE'][voteType.id]['_edit'] || readOnly)
        "
        >
        No
      </button>
      <button
        [class]="{
          toggle: true,
          affirmative: true,
          checked: vote?.status === true
        }"
        role="button"
        type="button"
        (click)="handleClick(true)"
        [disabled]="
          (!permsService.userPerms['COMMITTEEVOTETYPE'][voteType.id]['_edit'] || readOnly)
        "
        >
        Yes
      </button>
    </div>
  </span>
  @if (vote?.user?.person?.name) {
    <span class="row author-label">
      <span class="col-12">
        @if (vote?.user?.person?.name !== voteType.user?.person?.name) {
          <mat-icon
            matTooltip="Proxy Vote"
            aria-label="This user is voting by proxy"
            class="proxy-vote"
            >warning</mat-icon
            >
          }
          {{ getAuthorString() }}
        </span>
      </span>
    }
  </div>
